/** @format */

import React, { Component } from 'react';
import { Table, Segment, Header, Icon } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';

@inject('ClientsStore')
@observer
class ClientTableOverview extends Component {
  render() {
    const { ClientsStore } = this.props;
    const currentClient = ClientsStore.currentClient;
    return (
      <Segment>
        <div className="segment-header smaller">
          <Header as="h4">
            <small>
              <Icon name="user" />
            </small>
            Cliente
          </Header>
        </div>
        <div className="header-spacer"></div>
        <Table compact basic="very" fixed celled className="no-margin-top">
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <small>
                  <strong>Nome Cliente</strong>
                </small>
                <br />
                {this.props.renderContent(currentClient.data.name)}{' '}
                {this.props.renderContent(currentClient.data.surname)}
              </Table.Cell>
              <Table.Cell>
                <small>
                  <strong>Codice Fiscale/ Partita Iva</strong>
                </small>
                <br />
                {this.props.renderContent(currentClient.data.fiscalCode)}/
                {this.props.renderContent(currentClient.data.vatNumber)}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <small>
                  <strong>Email</strong>
                </small>
                <br />
                {this.props.renderContent(currentClient.data.email)}
              </Table.Cell>
              <Table.Cell>
                <small>
                  <strong>Cellulare</strong>
                </small>
                <br />
                {this.props.renderContent(currentClient.data.mobPhone)}
              </Table.Cell>
              <Table.Cell>
                <small>
                  <strong>Telefono fisso</strong>
                </small>
                <br />
                {this.props.renderContent(currentClient.data.landPhone)}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}

export default ClientTableOverview;
